import React from 'react';
import formatNumbers  from 'util/formatNumbers';

export function displayPayoutPercentage(cell, row) {
  const {SaleData = {PayoutPercentage: 'n/a'}, CustomData = {}} = row;

  if (CustomData.PayoutScaleApplied) {
    return (
      <span
        className="cursor-pointer blue"
        onClick={() => {
          this.setState({
            showModal: true,
            modalTitle: 'Payout applied details',
            modalContent: () => {
              return preparePayoutScaleData(CustomData);
            },
          });
        }}
      >
          {SaleData.PayoutPercentage}
        </span>
    );
  } else {
    return <span>{SaleData.PayoutPercentage}</span>;
  }
}

function preparePayoutScaleData(transactionCustomData) {
  let payoutScaleName = 'n/a';
  const payoutScaleMap = {
    seller_custom_payout_scale: 'Seller payout scale',
    settings_custom_payout_scale: 'Custom seller payout scale from Settings',
    no_payout_scale_applied: "No payout scale applied. Seller's payout was used",
    payout_scale_version_1: 'Payout scale version 1',
    payout_scale_version_2: 'Payout scale version 2',
    payout_scale_version_3: 'Payout scale version 3'
  };

  if (payoutScaleMap[transactionCustomData.PayoutScaleApplied]) {
    payoutScaleName = payoutScaleMap[transactionCustomData.PayoutScaleApplied];
  }

  return (
    <div>
      <div className="top5">
        <span className="text-bold">Payout scale applied:</span> <span>{payoutScaleName}</span>
      </div>
      {transactionCustomData.PayoutRuleApplied && (
        <div className="top5">
          <span className="text-bold">Rule applied:</span>{' '}
          <span>{JSON.stringify(transactionCustomData.PayoutRuleApplied)}</span>
        </div>
      )}
      {transactionCustomData.PayoutScaleID && (
        <div className="top5">
          <span className="text-bold">Payout scale ID:</span>{' '}
          <span>{transactionCustomData.PayoutScaleID}</span>
        </div>
      )}
    </div>
  );
}

export function calculateTransactionPayoutAmount(transaction, featureFlags) {
  const {SIIPEnabled} = featureFlags;
  const {ProductBasePriceWithDiscount = -1, PayoutPercentage} = transaction.SaleData;
  let payoutAmount =   formatNumbers.unformat(formatNumbers.toFixed(transaction.Amount  * (PayoutPercentage / 100), 2));

   if(SIIPEnabled &&  ProductBasePriceWithDiscount > -1) {
    payoutAmount =   formatNumbers.unformat(formatNumbers.toFixed(ProductBasePriceWithDiscount  * (PayoutPercentage / 100), 2));
   }

  return payoutAmount;
}